import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileDropComponent } from '../file-drop/file-drop.component';
import { ButtonComponent } from '../../../@core/components/ui/button/button.component';

export interface AdditionalActionConfig {
    label: string;
    icon?: string;
    severity?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'contrast';
    variant?: 'filled' | 'outlined' | 'text';
    key: string; // unique identifier for the action
}

@Component({
    selector: 'app-file-upload-with-actions',
    standalone: true,
    imports: [CommonModule, FileDropComponent, ButtonComponent],
    templateUrl: './file-upload-with-actions.component.html',
    styleUrls: ['./file-upload-with-actions.component.scss']
})
export class FileUploadWithActionsComponent {
    @Input() multiple: boolean = true;
    @Input() fileTypes: string[] = [];
    @Input() maxFileSize: number = 10 * 1000 * 1000;
    @Input() uploadedFiles: File[] = [];
    @Input() primaryButtonLabel: string = 'Upload';
    @Input() secondaryButtonLabel: string = 'Cancel';
    @Input() primaryButtonLoading: boolean = false;
    @Input() additionalActions: AdditionalActionConfig[] = [];
    @Input() hideActionButtons: boolean = false;

    @Output() filesChanged = new EventEmitter<File[]>();
    @Output() primaryAction = new EventEmitter<void>();
    @Output() secondaryAction = new EventEmitter<void>();
    @Output() additionalActionClicked = new EventEmitter<string>(); // emits the key of clicked action

    onFileUpload(files: File | File[]) {
        const filesArray = Array.isArray(files) ? files : (files ? [files] : []);
        this.uploadedFiles = [...filesArray];
        this.filesChanged.emit(this.uploadedFiles);
    }

    onRemoveFile(file: File) {
        this.uploadedFiles = this.uploadedFiles.filter(f => f !== file);
        this.filesChanged.emit(this.uploadedFiles);
    }

    onPrimaryAction() {
        this.primaryAction.emit();
    }

    onSecondaryAction() {
        this.secondaryAction.emit();
    }

    onAdditionalActionClick(actionKey: string) {
        this.additionalActionClicked.emit(actionKey);
    }
}

